// app/disable-route-reuse.strategy.ts
import { RouteReuseStrategy, DetachedRouteHandle, ActivatedRouteSnapshot } from '@angular/router'

export class DisableRouteReuseStrategy implements RouteReuseStrategy {
  shouldDetach(): boolean {
    return false
  }
  store(): void {}
  shouldAttach(): boolean {
    return false
  }
  retrieve(): DetachedRouteHandle | null {
    return null
  }
  // shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
  //   return future.routeConfig === curr.routeConfig && false
  // }
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Disable reuse for the business detail route
    if (future.routeConfig?.path === 'company/business/:id') {
      return false
    }
    return future.routeConfig === curr.routeConfig
  }
}
